module.exports = __webpack_public_path__ + "media/images/icon/blue/ico_delete-5e009eaffdadf38cad01229b6f034119.svg";